// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"4634d987","704":"4e9b9c8d","787":"3650da69"}[chunkId] + ".chunk.js";
};